import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "bsSize", "bsStyle", "disabled", "iconOnly", "splitButton", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var getSizeClassName = function getSizeClassName(bsSize) {
  return bsSize === 'xs' && 'btn-xs' || bsSize === 'sm' && 'btn-sm' || bsSize === 'lg' && 'btn-lg';
};
var DropdownToggleButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    bsSize = props.bsSize,
    bsStyle = props.bsStyle,
    disabled = props.disabled,
    iconOnly = props.iconOnly,
    splitButton = props.splitButton,
    className = props.className,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var labelButtonClasses = classNames(!splitButton && 'dropdown-toggle', 'btn', "btn-".concat(bsStyle), getSizeClassName(bsSize), iconOnly && 'btn-icon-only', disabled && 'disabled', className && !splitButton && className);
  return /*#__PURE__*/React.createElement("button", _extends({}, remainingProps, {
    id: splitButton ? "button-".concat(id) : id,
    role: "button",
    type: "button",
    className: labelButtonClasses,
    ref: ref
  }), children);
});
export default DropdownToggleButton;
DropdownToggleButton.propTypes = {
  disabled: PropTypes.bool,
  bsStyle: PropTypes.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
  className: PropTypes.string
};